import { ConfigProvider as AntConfigProvider } from 'antd'
import { useEffect } from 'react'
import type { ComponentProps } from 'react'

export const APP_PREFIX_CLS = 'app'
export const APP_ICON_PREFIX_CLS = 'appicon'

type AntConfigProviderProps = ComponentProps<typeof AntConfigProvider>

export interface AppConfigProviderProps extends AntConfigProviderProps {}

export const AppConfigProvider = ({ theme, ...props }: AppConfigProviderProps) => {
  useEffect(() => {
    AntConfigProvider.config({
      prefixCls: APP_PREFIX_CLS,
      iconPrefixCls: APP_ICON_PREFIX_CLS,
      ...(theme ? { theme } : {})
    })
  }, [theme])

  return (
    <AntConfigProvider prefixCls={APP_PREFIX_CLS} iconPrefixCls={APP_ICON_PREFIX_CLS} theme={theme} {...props} />
  )
}
